export default __webpack_public_path__ + "images/FHM.4c58a23.png";